'use strict';

// Polyfills
import 'babel-polyfill/dist/polyfill.min';
import '../../node_modules/objectFitPolyfill/dist/objectFitPolyfill.min';
import DetectedBrowser from './utils/detect-browser';
import Stickyfill from '../../node_modules/stickyfilljs/dist/stickyfill';

import NavBar from '../_partials/navbar/navbar';
import Footer from '../_partials/footer/footer';
import Journal from '../_modules/journal/journal';
import JournalSlider from '../_modules/journal-slider/journal-slider';
import SearchPage from '../_modules/search-page/search-page';
import Contacts from '../_modules/contacts/contacts';
import Templates from '../_partials/templates/templates';
import TopSection from '../_partials/top-section/top-section';
import Button from '../_partials/button/button';
import Who from '../_modules/who/who';
import Comments from '../_partials/comments/comments';
import TitleBar from '../_partials/title-bar/title-bar';
import Slider from '../_modules/article/slider';
import Tags from '../_modules/tags/tags';
import Social from '../_partials/social/social';
import Banner from '../_partials/banner/banner';

class Main {
  constructor() {
    this.wrapperDk = document.querySelector('.wrapper-dk');
    this.navbar = document.querySelector('.navbar');
    this.overlay = document.querySelector('.overlay');
    this.footer = document.querySelector('.footer-dk');
    this.journal = document.querySelector('.journal');
    this.journalSlider = document.querySelector('.journal-slider');
    this.searchPage = document.querySelector('.search-page');
    this.contacts = document.querySelector('.contacts');
    this.template = document.querySelector('.template');
    this.topSection = document.querySelector('.top-section');
    this.button = document.querySelector('.button');
    this.who = document.querySelector('.who');
    this.comments = document.querySelector('.comments');
    this.titleBar = document.querySelector('.title-bar');
    this.slider = document.querySelector('.article__content-slider');
    this.tags = document.querySelector('.tags');
    this.social = document.querySelector('.social');
    this.overlay = document.querySelector('.overlay');
    this.loader = document.querySelector('.loader');
    this.stickyAll = document.querySelectorAll('.sticky');
    this.banner = document.querySelector('.banner');
  }

  loadNow(opacity) {
    if (opacity <= 0) {
      this.loader.style.display = 'none';
    }
 else {
      this.loader.style.opacity = opacity;
      window.setTimeout(() => {
        this.loadNow(opacity - 0.1);
      }, 50);
    }
  }

  init() {
    if (new DetectedBrowser().checkSupportGrid()) {
      require('../_scripts/polyfill/grid/css-polyfills.min');
    }

    if (this.stickyAll) {
      Stickyfill.add(this.stickyAll);
    }

    if (this.navbar) {
      const navbar = new NavBar(this.overlay);
      navbar.init();
    }

    if (this.footer) {
      const footer = new Footer();
      footer.init();
    }

    if (this.journal) {
      const journal = new Journal();
      journal.init();
    }

    if (this.journalSlider) {
      const journalSlider = new JournalSlider();
      journalSlider.init();
    }

    if (this.searchPage) {
      const searchPage = new SearchPage(this.overlay);
      searchPage.init();
    }

    if (this.contacts) {
      const contacts = new Contacts();
      contacts.init();
    }

    if (this.template) {
      const template = new Templates();
      template.init();
    }

    if (this.topSection) {
      const topSection = new TopSection(this.overlay);
      topSection.init();
    }

    if (this.button) {
      const button = new Button();
      button.init();
    }

    if (this.who) {
      const who = new Who();
      who.init();
    }

    if (this.comments) {
      const comments = new Comments();
      comments.init();
    }

    if (this.titleBar) {
      const titleBar = new TitleBar();
      titleBar.init();
    }

    if (this.slider) {
      const slider = new Slider();
      slider.init();
    }

    if (this.tags) {
      const tags = new Tags();
      tags.init();
    }

    if (this.social) {
      const social = new Social();
      social.init();
    }

    if (this.banner) {
      const banner = new Banner();
      banner.init();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const main = new Main();
  main.loadNow(1);
  main.init();
});
